import type EnType from '../en-US/settings';

export default {
  'app.settings.hasNoSetting': '未設定',
} satisfies typeof EnType;
